import { ApiError, type AuthMeDTO } from './api';

// Retry only the read-only session probe during short API startup/proxy outages.
// Never apply this helper to login, publishing or other mutations.
export async function readAuthWithRecovery(
  read: () => Promise<AuthMeDTO>,
  wait: (milliseconds: number) => Promise<void> = (milliseconds) => new Promise(resolve => setTimeout(resolve, milliseconds)),
): Promise<AuthMeDTO> {
  const delays = [1000, 2000, 4000];
  for (let attempt = 0; ; attempt++) {
    try { return await read(); }
    catch (error) {
      if (!(error instanceof ApiError) || ![0, 502, 503, 504].includes(error.status) || attempt >= delays.length) throw error;
      await wait(delays[attempt]!);
    }
  }
}
